import { newApi } from "../api";

export const requestUpdateComputerData = async (computerId: string, toast?: any) => {
  await newApi().post(`/commands/request-update-data/${computerId}`);
};
